/**
 * Utility to check if Sentry logging should be enabled
 * This helps save on Sentry quota for local development
 */

export const isSentryEnabled = () => {
  // Check environment variable first
  const envFlag = import.meta.env.VITE_ENABLE_SENTRY;
  
  // Convert string to boolean (Vite env vars are always strings)
  if (envFlag === 'true') return true;
  if (envFlag === 'false') return false;
  
  // Fallback: enable Sentry for production and staging, disable for development
  const appEnv = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;
  return appEnv === 'production' || appEnv === 'staging';
};

/**
 * Safe Sentry capture that respects the environment flag
 */
export const safeSentryCapture = (sentryFunction, error, context = {}) => {
  if (!isSentryEnabled()) {
    console.log('Sentry disabled - would have logged:', {
      error: error.message || error,
      context
    });
    return;
  }
  
  return sentryFunction(error, context);
};
